/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchScheduleEndBounded = {
  Bounded: "bounded",
} as const;
export type KillswitchScheduleEndBounded = ClosedEnum<
  typeof KillswitchScheduleEndBounded
>;

/** @internal */
export const KillswitchScheduleEndBounded$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleEndBounded
> = z.enum(KillswitchScheduleEndBounded);
/** @internal */
export const KillswitchScheduleEndBounded$outboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleEndBounded
> = KillswitchScheduleEndBounded$inboundSchema;
